<template>
  <div>
    <el-card>
      <div slot="header"><el-button type="text" icon="el-icon-arrow-left" @click="$router.back()">返回</el-button> 博主详情</div>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="用户名">{{ blogger.username }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="blogger.status==='active'?'success':'danger'" size="small">{{ blogger.status === 'active' ? '正常' : '已冻结' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{ blogger.realName }}</el-descriptions-item>
        <el-descriptions-item label="支付宝">{{ blogger.alipayAccount }}</el-descriptions-item>
        <el-descriptions-item label="累计收入">¥{{ blogger.totalIncome }}</el-descriptions-item>
        <el-descriptions-item label="可提余额">¥{{ blogger.withdrawable }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag :type="blogger.auditStatus==='approved'?'success':'warning'" size="small">
            {{ blogger.auditStatus === 'approved' ? '已通过' : blogger.auditStatus === 'rejected' ? '已拒绝' : '待审核' }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { adminApi } from '../api';

export default {
  data() {
    return { blogger: {} };
  },
  created() { this.fetch(); },
  methods: {
    async fetch() {
      const id = this.$route.params.id;
      const res = await adminApi.listBloggers({ page: 1, size: 100 });
      const found = res.data.list.find(b => b.id === parseInt(id));
      if (found) this.blogger = found;
    }
  }
};
</script>
